import React from 'react';
import './FeaturedProducts.css';
import { Link } from 'react-router-dom';

const products = [
  {
    name: 'Skin & Eye Care Film',
    desc: 'Protect yourself and passengers from harmful UV rays while maintaining visibility.',
    icon: '🛡️',
    link: '/skin-eye-care',
  },
  {
    name: '3 Ply Reflective Window Film',
    desc: 'Premium multi-layered film for maximum heat rejection and privacy.',
    icon: '🪟',
    link: '/3-ply-reflective',
  },
  {
    name: 'Pre-Cut Films',
    desc: 'Precisely cut films for perfect fit and easy installation.',
    icon: '✂️',
    link: '/pre-cut-films',
  }
];

const FeaturedProducts = () => (
  <section className="featured-products-section">
    <h2 className="featured-title">Our Product Range</h2>
    <div className="featured-products-list">
      {products.map((product) => (
        <div className="product-card" key={product.name}>
          <div className="product-icon-only" style={{ fontSize: 44 }}>{product.icon}</div>
          <div className="product-name-only">{product.name}</div>
          <div className="product-desc">{product.desc}</div>
          <Link to={product.link} className="learn-more-btn">Learn More</Link>
        </div>
      ))}
    </div>
  </section>
);

export default FeaturedProducts; 